<template>
  <div class="dataForm" style="min-width:800px;">
    <el-form
    :ref="el => dataForm[0] = el"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    >
      <slot name="baseInfo"/>
      <div class="form-title mb-10">
        <span class="label blue" >基</span>
        <span class="left">基本信息</span>
      </div>
      <div class="underlineForm">
        <el-form-item label="快递公司" prop="expressId">
          <el-select :filterable="true"
v-model="ruleForm.expressId"
class="filter-item"
placeholder="输入关键字搜索"
clearable
remote
@focus="expressRemoteMethod('')"
:remote-method="query => expressRemoteMethod(query)"
          >
            <template v-if="expressOption.length">
              <el-option
                v-for="item in expressOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>

        <!-- 发货 -->
        <template v-if="sendFlag === 1">
          <el-form-item label="API自动化" prop="automation">
            <el-select :filterable="true" v-model="ruleForm.automation" class="filter-item" placeholder="输入关键字搜索" clearable>
              <template v-if="automationOption.length">
                <el-option
                  v-for="item in automationOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </el-form-item>
          <!-- automation=true -->
          <template v-if="ruleForm.automation">
            <el-form-item label="发货人信息" prop="shipperInfoId">
              <el-select :filterable="true" v-model="ruleForm.shipperInfoId" class="filter-item" placeholder="输入关键字搜索" clearable remote :remote-method="getShipperOptionRemote" @focus="getShipperOptionRemote('')">
                <template v-if="shipperOption.length">
                  <el-option
                    v-for="item in shipperOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </template>
                <el-option v-else :value="-1" disabled>暂无数据</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保价" prop="insure">
              <el-input v-model="ruleForm.insure" type="input" class="filter-item"></el-input>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="物品类型" prop="type">
          <el-select :filterable="true" v-model="ruleForm.type" class="filter-item" placeholder="输入关键字搜索" clearable>
            <template v-if="typesOption.length">
              <el-option
                v-for="item in typesOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="ruleForm.expressNo" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="物品名称" prop="goods">
          <el-input v-model="ruleForm.goods" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item :label="sendFlag === 1 ? '发件人' : '收件人'" prop="contact">
          <!-- <el-input v-model="ruleForm.contact" type="input" class="filter-item"></el-input> -->
          <el-select :filterable="true" v-model="ruleForm.contact" class="filter-item" placeholder="输入关键字搜索" clearable @focus="getUserOptionRemote('')">
            <template v-if="userOption.length">
              <el-option
                v-for="item in userOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="sendFlag === 1 ? '发件人号码' : '收件人号码'" prop="phone">
          <el-input v-model="ruleForm.phone" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="省市县" prop="place">
          <el-input v-model="ruleForm.place" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="placeDetail">
          <el-input v-model="ruleForm.placeDetail" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="mark" class="fullWidth">
          <el-input v-model="ruleForm.mark" type="textarea" class="filter-item" clearable></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { getDetailById } from '@/apis/Dictionary'

import { ElMessage } from 'element-plus'
import { createLogistics, updateLogistics } from '@/apis/logistics'

import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import { pageVo } from '@/utils/index'

export default defineComponent({
  components: {
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    selectionSource: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    selectcSourceId: { type: String, required: false, default: null as any },
    mode: { type: String, required: false, default: '' },
    sendFlag: { type: Number, required: false, default: 1 },
    purchasDetail: { type: Object, required: false, default: () => null }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref([])
    const BusinessList = ref({})

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      sendFlag: props.sendFlag,
      submitLoading: false,
      ruleForm: {
        expressId: '',
        shipperInfoId: '',
        insure: '',
        automation: '',
        type: '' as any,
        sourceId: '' as any,
        expressNo: '',
        goods: '',
        contact: '',
        phone: '',
        place: '',
        placeDetail: '',
        mark: ''
      },
      sourceForm: {} as any,
      rules: {
        expressId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        type: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        sourceId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        expressNo: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        // goods: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        // contact: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        // phone: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        // place: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        // placeDetail: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        automation: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: []
      },
      shipperOption: [],
      expressOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      typesOption: [],
      automationOption: [],
      excludeIds: [],
      sourceOption: [],
      userOption: [],

      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      expressRemoteMethod: debounce((query: string | number) => {
        getPageList('express/page?', {
          name: query,
          ...pageVo
        }).then((res: any) => {
          dataMap.expressOption = res.data || []
        })
      }, 500),
      async handleSourceChange(value: any) {
        if (!value) {
          return
        }
        const { type } = dataMap.ruleForm
        if ([1, 2].includes(Number(type))) {
          const result = await getPageList(`business/${value}/actions/contacts`)
          if (result && result.length) {
            let tempBusinessContact = result.find((item: any) => {
              return item.defaultValue
            }) || {}
            if (!Object.keys(tempBusinessContact).length) {
              tempBusinessContact = result[0]
            }
            dataMap.getUserOptionRemote()
            dataMap.ruleForm.contact = dataMap.ruleForm.contact || tempBusinessContact.id
            dataMap.ruleForm.phone = dataMap.ruleForm.phone || tempBusinessContact.phone
            dataMap.ruleForm.place = dataMap.ruleForm.place || tempBusinessContact.address
            dataMap.ruleForm.placeDetail = dataMap.ruleForm.placeDetail || tempBusinessContact.addressDetail
          }
        }
        dataMap.sourceForm = dataMap.sourceOption.find((k: any) => k.id === value) || {}
      },
      getShipperOptionRemote: debounce((query: string | number) => {
        getPageList(`shipper/page?name=${query}&page=1&size=20`).then((res: any) => {
          dataMap.shipperOption = res.data || []
        })
      }, 500),
      getUserOptionRemote() {
        getPageList('user/dropdown/availableUses').then((res: any) => {
          dataMap.userOption = res || []
        })
      },
      handleAddSource() {
        dataMap.dialogVisible = true
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const Forms = unref(dataForm)
        const promises = Forms.map((form: any) => {
          return form.validate()
        })
        Promise.all(promises).then(async() => {
          dataMap.submitLoading = true
          try {
            const tempData = { ...dataMap.ruleForm, sendFlag: props.sendFlag }
            const formSate = !props.id ? 'add' : 'edit'
            if (formSate === 'add') {
              await createLogistics(tempData)
            } else {
              await updateLogistics(props.id, tempData)
            }
            dataMap.submitLoading = false
            context.emit('update:visibel')
            context.emit('submit')
            ElMessage({
              message: !props.id ? '创建成功' : '编辑成功',
              type: 'success',
              duration: 2000
            })
          } catch (err:any) {
            console.log(err, 'err')
            dataMap.submitLoading = false
            if (err && err.errors) {
              err.errors.forEach((item: any) => {
                const field = dataMap.rules[item.field][0]
                if (field) {
                  field.message = null
                  nextTick(() => {
                    field.message = item.defaultMessage
                  })
                }
              })
            }
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          dataForm.value.forEach((form: any) => {
            form.clearValidate()
          })
        })
      },
      getOptions() {
        getPageList('dropdown/LogisticsType').then((res: any) => {
          if (!props.selectcSourceId) {
            dataMap.typesOption = res?.filter((kk: any) => [0].includes(kk.id))
            dataMap.ruleForm.type = 0
          }
          if (props.purchasDetail) {
            dataMap.typesOption = res?.filter((kk: any) => [5, 6].includes(kk.id))
          }
        })
        if (props.sendFlag === 1) {
          getPageList('dropdown/WhetherType').then((res: any) => {
            dataMap.automationOption = res || []
          })
        }
      }
    })
    onMounted(async() => {
      dataMap.expressRemoteMethod('')
      dataMap.getShipperOptionRemote('')
      dataMap.getOptions()
      dataMap.ruleForm.sourceId = props.selectcSourceId
      if (props.id) {
        const result = await getDetailById(props.api, props.id)
        result.automation = Number(result.automation)
        dataMap.ruleForm = result
      }
      if (props.purchasDetail) {
        const { expressId, id } = props.purchasDetail
        dataMap.ruleForm.expressId = expressId
        dataMap.ruleForm.sourceId = id
      }
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, BusinessList }
  }
})
</script>
